<tun-panel-header
  tunThemed
  [isCurrentMusicCollection]="isCurrentMusicCollection"
  [title]="title"
  [showClose]="showClose"
  (close)="onCloseClick()"
>
  <div class="left-header-buttons">
    <tun-icon-button
      tunTooltipOnHover
      [tooltipText]="'tooltip.trackList.addAllToQueue'"
      [checkAccessToAddToQueue]="true"
      [height]="heigthForTitle$ | async"
      (clickWithAccess)="onAddToQueueClick()"
    >
      <tun-add-to-queue-icon></tun-add-to-queue-icon>
    </tun-icon-button>
  </div>
  <div tunThemed class="right-header-buttons">
    <div>
      <tun-icon-button
        *ngIf="enableSongRequests"
        tunPopupOnClick
        #suggestionButton
        [closeOnPopupClick]="false"
        [closeOnOutsideElementClick]="true"
        [closePopupAfterMouseLeave]="false"
        [height]="heigthForTitle$ | async"
        (togglepopup)="onToggleSuggestionPopup($event)"
      >
        <tun-suggestion-icon></tun-suggestion-icon>
      </tun-icon-button>
    </div>
    <div>
      <!-- sort button-->
      <tun-icon-button
        tunTooltipOnHover
        [tooltipText]="'tooltip.trackList.sort'"
        tunSongSortOnClick
        [height]="heigthForTitle$ | async"
        (songSortModeChange)="onSongSortModeChange($event)"
      >
        <tun-sort-icon></tun-sort-icon>
      </tun-icon-button>
      <tun-icon-button
        tunTooltipOnHover
        [tooltipText]="'tooltip.trackList.addAllToCustomList'"
        [tooltipEnabled]="!showingAddToListPopup"
        [height]="heigthForTitle$ | async"
        #addToListButton
        tunPopupOnClick
        (togglepopup)="onToggleAddToListPopup($event)"
        [closeOnPopupClick]="false"
        [closeOnOutsideElementClick]="true"
      >
        <tun-add-to-list-icon></tun-add-to-list-icon>
      </tun-icon-button>
    </div>
  </div>
</tun-panel-header>

<ng-container [ngSwitch]="playlistState">
  <tun-song-grid
    *ngSwitchCase="PlaylistState.tracks"
    [playlist]="audioFiles"
    [showAddArrow]="canAddSongs"
    [songSortMode]="songSortMode"
    [showPopupDelete]="showPopupDelete"
    (trackEvent)="onTrackEvent($event)"
    borderColor="#171C1D"
    [maxScrollbarHeight]="
      (availableHeightForPlayer$ | async) -
      (heightPerItem$ | async) -
      (heightForHeader$ | async) -
      (heightForTopBar$ | async) * 2
    "
  ></tun-song-grid>

  <ng-container *ngSwitchCase="PlaylistState.loading">
    <tun-loader text="search.feedback.busy"></tun-loader>
  </ng-container>

  <div  *ngSwitchCase="PlaylistState.empty"
    class="feedback-container">
    <p translate>
      search.feedback.empty
    </p>
  </div>

</ng-container>

